module.exports = __webpack_public_path__ + "static/media/logo-inverse.2e20ab46.svg";